export const NEWS_ITEM_FEATURE_KEY = 'newsItem';
